/* eslint-disable @nx/enforce-module-boundaries */
import { ReactionsIcon } from '@mybridge/icons';
import { HStack, VStack } from '@mybridge/ui/layout';
import { useContext } from 'react';

import { Text } from '@mybridge/ui/text';
import { PostFormContext } from '../context';
import {
  Switch,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from '@mybridge/ui';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const Reactions = () => {
  const {
    canComment,
    agreeDisAgree,
    setAgreeDisAgreeVisibility,
    setCanCommentVisibility,
  } = useContext(PostFormContext);
  const { t } = useTranslator();


  return (
    <Popover placement="bottom-start" gutter={2}>
      <PopoverTrigger>
        <HStack
          as="button"
          color="#5B5B5B"
          fontSize="sm"
          width="202px"
          height="40px"
          padding="10px 14px"
          gap="10px"
          borderRadius="20px"
          border="1px 1px 0px 1px"
          boxShadow="0px 2px 6px 0px #00000033"
        >
          <ReactionsIcon />
          <Text color="gray.700">{t('createPost.reactions') || "Reactions"}</Text>
        </HStack>
      </PopoverTrigger>

      <PopoverContent width="202px" borderRadius="10px">
        <PopoverBody>
          <VStack gap="8px" alignItems="flex-stretch">
            <HStack justifyContent="space-between" alignItems="center">
              <Text flex="1" textAlign="left" fontSize="sm">
                {t('createPost.comment') || "Comment"}
              </Text>
              <Switch
                id="canComment"
                isChecked={canComment}
                onChange={(e) => setCanCommentVisibility(e.target.checked)}
              />
            </HStack>
            <HStack justifyContent="space-between" alignItems="center">
              <Text flex="1" textAlign="left" fontSize="sm">
                {t('createPost.agreeDisagree') || "Agree & Disagree"}
              </Text>
              <Switch
                id="agreeDisAgree"
                isChecked={agreeDisAgree}
                onChange={(e) => setAgreeDisAgreeVisibility(e.target.checked)}
              />
            </HStack>
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
